import { memo } from "react";

interface PickerDividerProps {
  itemHeight: number;
}

export const PickerDivider = memo(function PickerDivider({
  itemHeight,
}: PickerDividerProps) {
  return (
    <div
      style={{
        height: itemHeight,
        marginTop: -(itemHeight / 2),
      }}
      className="absolute top-1/2 left-0 w-full pointer-events-none"
    >
      <div className="absolute top-0 bottom-auto left-0 right-0 h-full rounded-2xl bg-select-active" />
    </div>
  );
});
